var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:[
    _vm.sizeCustomize,
    _vm.textAlignCustomize,
    _vm.weightCustomize,
    _vm.hasColor ? _vm.colorCustomize : 'text-ontick-carbon-900 dark:text-gray-300',
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }